module.exports = __webpack_public_path__ + "static/media/apis-programming@mobile.348e34cd.svg";